<template>
  <div v-if="purchaseTasks.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('PurchaseTasks', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/purchase-tasks/detail/' + purchaseTasks.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("PurchaseTasks.actions.detail") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("PurchaseTasks.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 编辑 -->
      <v-tooltip
        top
        v-if="showComplete && $permission.permissionAllow('PurchaseTasks', 'complete')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('complete')
                  : $router.push('/purchase-tasks/detail/' + purchaseTasks.id + '/complete');
              })
            "
          >
            {{ $t("PurchaseTasks.actions.complete") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchaseTasks.actions.complete") }}</span>
      </v-tooltip>
    </v-sheet>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "PurchaseTaskDetailsActions",

  props: {
    detailMode: Boolean,
    purchaseTasks: Object,
    showView: Boolean,
    showComplete: Boolean,
  },
  components: {
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({

  }),

  methods: {

  },
};
</script>